import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import Home from './pages/home'
import SignUp from './pages/signup'
import Login from './pages/login'
import Journals from './pages/journals'
import Journal from './pages/journal'
import NewJournal from './pages/new_journal'
// import Admin from './pages/admin'
import EditJournal from './pages/edit_journal'
import Front from './pages/front'
import PageNotFound from './pages/page_not_found'
import PrivateRoute from './components/private_route'
import Calendar from './pages/calendar'
import Profile from './pages/profile'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Front />} />
        <Route path="/*" element={<PageNotFound />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/login" element={<Login />} />

        <Route path="/home" element={<PrivateRoute />}>
          <Route path="/home" element={<Home />} />
        </Route>
        <Route path="/journals" element={<PrivateRoute />}>
          <Route path="/journals" element={<Journals />} />
        </Route>
        {/* <Route path="/admin" element={<PrivateRoute />}>
          <Route path="/admin" element={<Admin />} />
        </Route> */}
        <Route path="/journals/:id" element={<PrivateRoute />}>
          <Route path="/journals/:id" element={<Journal />} />
        </Route>
        <Route path="/journals/:id/edit" element={<PrivateRoute />}>
          <Route path="/journals/:id/edit" element={<EditJournal />} />
        </Route>
        <Route path="/new_journal" element={<PrivateRoute />}>
          <Route path="/new_journal" element={<NewJournal />} />
        </Route>
        <Route path="/calendar" element={<PrivateRoute />}>
          <Route path="/calendar" element={<Calendar />} />
        </Route>
        <Route path="/profile" element={<PrivateRoute />}>
          <Route path="/profile" element={<Profile />} />
        </Route>
      </Routes>
      <ToastContainer />
    </BrowserRouter>
  )
}

export default App
